import Trix from 'trix'
import '@rails/actiontext'

Trix.config.attachments.preview.caption.name = false
Trix.config.attachments.preview.caption.size = false

Trix.config.blockAttributes.heading2 = {
  tagName: "h2",
  terminal: true,
  breakOnReturn: true,
  group: false
}

Trix.config.blockAttributes.heading3 = {
  tagName: "h3",
  terminal: true,
  breakOnReturn: true,
  group: false
}

class BaseElement extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
}

function innerHTML(alignment) {
  return `
    <style>
      :host {
        text-align: ${alignment};
        width: 100%;
        display: block;
      }
    </style>

    <slot></slot>
  `
}

export class AlignCenterElement extends BaseElement {
  constructor() {
    super()

    this.shadowRoot.innerHTML = innerHTML('center')
  }
}

export class AlignRightElement extends BaseElement {
  constructor() {
    super()

    this.shadowRoot.innerHTML = innerHTML('right')
  }
}

window.customElements.define('align-center', AlignCenterElement)
window.customElements.define('align-right', AlignRightElement)

Trix.config.blockAttributes.alignCenter = {
  tagName: 'align-center',
  group: false,
  exclusive: true
}

Trix.config.blockAttributes.alignRight = {
  tagName: 'align-right',
  group: false,
  exclusive: true
}
